export const KEY_ENTER = 'Enter';
